<template>
  <v-container>
    <v-btn @click="$router.go(-1)" class="mb-12">{{ $t('gallery.back') }}</v-btn>

    <v-row>
      <v-col cols="12">
        <h1 class="gallery-title text-center mb-6">{{ $t('gallery.gallery') }}</h1>
      </v-col>
    </v-row>

    <section v-for="section in sections" :key="section.title" class="mt-15">
      <h2 class="mb-3">{{ $t(section.title) }}</h2>
      <v-row>
        <v-col
          cols="6"
          sm="4"
          md="3"
          v-for="(img, index) in section.list"
          :key="index"
        >
          <v-img
            :src="`https://res.cloudinary.com/di8h1fsel/image/upload/f_auto,q_auto,w_400${img}`"
            lazy-src="https://res.cloudinary.com/di8h1fsel/image/upload/f_auto,q_auto,w_20${img}`"
            width="300"
            height="200"
            aspect-ratio="1.5"
            eager="false"
            class="rounded-lg"
            @click="openLightbox(img, section.list)"
          ></v-img>
        </v-col>
      </v-row>
    </section>

    <v-dialog v-model="lightbox" max-width="900px">
      <v-card>
        <v-btn icon @click="prevImage" :disabled="currentIndex === 0" class="lightbox-left">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-img
          :src="`https://res.cloudinary.com/di8h1fsel/image/upload/f_auto,q_auto,w_1600${selectedImage}`"
          contain
        ></v-img>

        <v-btn icon @click="nextImage" :disabled="currentIndex === currentGallery.length - 1" class="lightbox-right">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "HouseGallery",
  data() {
    return {
      lightbox: false,
      selectedImage: null,
      currentIndex: 0,
      currentGallery: [],
      livingroom: ["/livingroom/18.jpg", "/livingroom/19.jpg", "/livingroom/20.jpg", "/livingroom/24.jpg", "/livingroom/32.jpg", "/livingroom/33.jpg", "/livingroom/34.jpg", "/livingroom/59.jpg", "/livingroom/60.jpg", "/livingroom/61.jpg", "/livingroom/62.jpg", "/livingroom/63.jpg", "/livingroom/64.jpg", "/livingroom/65.jpg", "/livingroom/66.jpg", "/livingroom/68.jpg", "/livingroom/69.jpg", "/livingroom/89.jpg", "/livingroom/90.jpg", "/livingroom/91.jpg"],
      pool: [
        "/pool/6.jpg",
        "/pool/7.jpg",
        "/pool/8.jpg",
        "/pool/9.jpg",
        "/pool/10.jpg",
        "/pool/21.jpg",
        "/pool/22.jpg",
        "/pool/23.jpg",
        "/pool/25.jpg",
        "/pool/26.jpg",
        "/pool/27.jpg",
        "/pool/28.jpg",
        "/pool/29.jpg",
        "/pool/30.jpg",
        "/pool/31.jpg",
        "/pool/67.jpg",
        "/pool/72.jpg",
        "/pool/73.jpg",
        "/pool/74.jpg",
        "/pool/75.jpg",
        "/pool/76.jpg",
        "/pool/77.jpg",
        "/pool/78.jpg",
        "/pool/79.jpg",
        "/pool/80.jpg",
        "/pool/81.jpg",
        "/pool/82.jpg",
        "/pool/83.jpg",
        "/pool/84.jpg",
        "/pool/85.jpg",
        "/pool/86.jpg",
        "/pool/87.jpg",
        "/pool/88.jpg",
        "/pool/93.jpg",
        "/pool/94.jpg",
        "/pool/95.jpg",
        "/pool/96.jpg",
        "/pool/97.jpg",
        "/pool/98.jpg",
        "/pool/99.jpg",
        "/pool/100.jpg",
        "/pool/110.jpg",
        "/pool/113.jpg",
        "/pool/122.jpg",

      ],
      surrounding: [
        "/surrounding/1.jpg",
        "/surrounding/2.jpg",
        "/surrounding/3.jpg",
        "/surrounding/5.jpg",
        "/surrounding/4.jpg",
        "/surrounding/101.jpg",
        "/surrounding/102.jpg",
        "/surrounding/103.jpg",
        "/surrounding/104.jpg",
        "/surrounding/105.jpg",
        "/surrounding/106.jpg",
        "/surrounding/107.jpg",
        "/surrounding/108.jpg",
        "/surrounding/109.jpg",
        "/surrounding/111.jpg",
        "/surrounding/114.jpg",
        "/surrounding/115.jpg",
        "/surrounding/116.jpg",
        "/surrounding/117.jpg",
        "/surrounding/118.jpg",
        "/surrounding/119.jpg",
        "/surrounding/120.jpg",
        "/surrounding/121.jpg",
        "/surrounding/123.jpg",
      ],
      bedroom_one: [
        "/bedroom_first/12.jpg",
        "/bedroom_first/14.jpg",
        "/bedroom_first/15.jpg",
        "/bedroom_first/16.jpg",
        "/bedroom_first/35.jpg",
        "/bedroom_first/36.jpg",
        "/bedroom_first/38.jpg",
        "/bedroom_first/39.jpg",
        "/bedroom_first/40.jpg",
        "/bedroom_first/41.jpg",
        "/bedroom_first/42.jpg",
        "/bedroom_first/43.jpg",
        "/bedroom_first/44.jpg",
        "/bedroom_first/92.jpg",
      ],
      bedroom_two: [
        "/bedroom_second/45.jpg",
        "/bedroom_second/46.jpg",
        "/bedroom_second/47.jpg",
        "/bedroom_second/48.jpg",
      ],
      bedroom_three: [
        "/bedroom_third/37.jpg",
        "/bedroom_third/51.jpg",
        "/bedroom_third/52.jpg",
        "/bedroom_third/53.jpg",
        "/bedroom_third/54.jpg",
        "/bedroom_third/55.jpg",
      ],
      bathroom_one: [
        "/bathroom_first/70.jpg",
        "/bathroom_first/71.jpg",
      ],
      bathroom_two: [
        "/bathroom_second/49.jpg",
        "/bathroom_second/50.jpg",
      ],
      bathroom_three: [
        "/bathroom_third/11.jpg",
        "/bathroom_third/56.jpg",
        "/bathroom_third/57.jpg",
        "/bathroom_third/58.jpg",
      ],
    };
  },
  computed: {
    sections() {
      return [
        { title: "gallery.living_room", list: this.livingroom },
        { title: "gallery.pool_and_bbq", list: this.pool },
        { title: "gallery.surroundings", list: this.surrounding },
        { title: "gallery.first_bedroom", list: this.bedroom_one },
        { title: "gallery.second_bedroom", list: this.bedroom_two },
        { title: "gallery.third_bedroom", list: this.bedroom_three },
        { title: "gallery.first_bathroom", list: this.bathroom_one },
        { title: "gallery.second_bathroom", list: this.bathroom_two },
        { title: "gallery.third_bathroom", list: this.bathroom_three },
      ];
    }
  },
  methods: {
    preloadImages() {
      const preload = (index) => {
        if (index >= 0 && index < this.currentGallery.length) {
          const img = new Image();
          img.src = `https://res.cloudinary.com/di8h1fsel/image/upload/f_auto,q_auto,w_1600${this.currentGallery[index]}`;
        }
      };

      preload(this.currentIndex + 1);
      preload(this.currentIndex - 1);
    },
    openLightbox(img, gallery) {
      this.currentGallery = gallery;
      this.currentIndex = gallery.indexOf(img);
      this.selectedImage = img;
      this.lightbox = true;
      this.preloadImages();
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.selectedImage = this.currentGallery[this.currentIndex];
        this.preloadImages();
      }
    },
    nextImage() {
      if (this.currentIndex < this.currentGallery.length - 1) {
        this.currentIndex++;
        this.selectedImage = this.currentGallery[this.currentIndex];
        this.preloadImages();
      }
    }
  }
}
</script>

<style scoped>
.gallery-title {
  position: relative;
  padding-bottom: 20px;
  font-weight: bold;
  font-family: "Lexend Tera", sans-serif;
}

.gallery-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, #4a90e2, #a0a0a0);
  border-radius: 1px;
}

h2 {
  font-weight: bold;
  font-family: "Lexend Tera", sans-serif;
  padding-left: 8px;
}

.lightbox-left,
.lightbox-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.lightbox-left {
  left: 8px;
}

.lightbox-right {
  right: 8px;
}
</style>
